import React, { memo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Paper from '@mui/material/Paper';
import { Box, useMediaQuery } from '@mui/material';
import theme from '../../../../assets/theme';
import SoftTypography from '../../../../components/SoftTypography';

const TrainingRequired = () => {
  const { t } = useTranslation();
  const matches = useMediaQuery(theme.breakpoints.up('sm'));
  const { grey, error } = theme.palette;

  console.log('Error: ', error);

  return (
    <Paper
      variant="outlined"
      className={`${
        matches ? 'travel-alerts-desktop' : 'travel-alerts-mobile'
      } travel-alerts`}
      style={{
        borderColor: grey[500],
        height: '100px',
        width: '100%',
      }}
    >
      <SoftTypography variant="body3" style={{ color: error.main }}>
        {t('WELCOME_PAGE.TRAINING_REQUIRED.title')}
      </SoftTypography>
      <Box sx={{ marginTop: '.5rem' }}>
        <SoftTypography component="span" variant="body2">
          {t('WELCOME_PAGE.TRAINING_REQUIRED.subtext')}
        </SoftTypography>
      </Box>
    </Paper>
  );
};

export default memo(TrainingRequired);
